import { ID_TOKEN_KEY } from '@/contexts/workspaceContext';
import { GSQLCommand } from '@/pages/editor/result/CommandExecutor';

export async function requestGSQLCommand(cmd: GSQLCommand, host: string, currentGraph: string) {
  const res = await fetch(`https://${host}/api/gsql-command`, {
    method: 'post',
    body: JSON.stringify({ command: cmd.GSQLCode, Cookie: { graph: currentGraph, fromGsqlServer: false } }),
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem(ID_TOKEN_KEY)}`,
    },
  });

  return res;
}
